/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import ErrorPopup from '../../../Display/NDC/component/ErrorPopup';
import {
  CODE_VALUE_EXIST,
  CODE_VALUE_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  addCodeValueRow,
  deleteCodeValueRow,
  setChildCodeValueError,
  setCodeTableErrorMessage,
  setCodeTableSuccessMessage,
  setDataChangeTried,
  updateChildUserId,
  setDuplicateFound,
} from '../store/actions';
import CodeTableCustomTextField from './CodeTableCustomTextField';
import DeleteBoxRender from './deleteBoxRender';
import {
  CODE_VALUE_CELL_HEAD,
  CODE_VALUE_CELL_HEAD_DISABLE,
} from './tableHead';

const CodeValueTable = forwardRef(
  ({ selectedParentKey, fullScreen, setFullScreen, isReadOnly }, ref) => {
    const dispatch = useDispatch();
    const [openDelete, setOpenDelete] = useState(false);
    const [childSeleted, setChildSelected] = useState(null);
    const [keyValue, setKeyValue] = useState([]);
    const [showViewHistory, setShowViewHistory] = useState(false);
    const dataChangeTried = useSelector(
      (state) => state?.sharedState?.CodeTableReducer?.dataChangeTried
    );
    const logInUser = useSelector(
      (state) => state?.sharedState?.SharedReducer?.logInUser
    );
    const [errorModal, setErrorModal] = useState(false);
    const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
    const handleBlur = (props, compareData) => {
      if (props && !props.data.isNewRecord) {
        const index = compareData.findIndex(
          (item) => item.codeDomainKey === props.data.codeValueID.codeDomainKey
        );

        if (index !== -1) {
          const resultIndex = compareData[index].codeValue.findIndex(
            (item) => item.index === props.data.index
          );
          if (resultIndex !== -1) {
            const result = compareData[index].codeValue[resultIndex];

            if (
              props.data.longDescription !== result.longDescription ||
              props.data.shortDescription !== result.shortDescription ||
              props.data.codeValueID.codeValue !== result.codeValueID.codeValue
            ) {
              dispatch(updateChildUserId(index, resultIndex, logInUser));
            } else {
              dispatch(
                updateChildUserId(index, resultIndex, result.lastUpdateUserId)
              );
            }
          }
        }
      }
      dispatch(setDataChangeTried(Math.random()));
      resetSuccessMessage();
    };

    const addRow = (e, data) => {
      // console.log(data, selectedParentKey);
      let value = data ? data : selectedParentKey;
      dispatch(addCodeValueRow(value, logInUser));
      resetSuccessMessage();
      handleBlur();
    };

    const handleDeleteRow = () => {
      dispatch(
        deleteCodeValueRow(
          selectedParentKey,
          childSeleted.data,
          // childSeleted.rowIndex
          logInUser
        )
      );
      handleBlur();
      resetSuccessMessage();
      setOpenDelete(false);
      setChildSelected(null);
    };

    useEffect(() => {
      checkCodeValue();
    }, [dataChangeTried]);
    const checkCodeValue = () => {
      const data =
        (selectedParentKey &&
          selectedParentKey.codeValue &&
          selectedParentKey.codeValue.filter((item) => !item.deleteFlag)) ||
        [];

      if (data.length > 0) {
        const emptyFilterArr = data.filter(
          (item) =>
            !item.codeValueID.codeValue || !item.codeValueID.codeValue.trim()
        );

        if (emptyFilterArr.length > 0) {
          dispatch(setChildCodeValueError(true));
          dispatch(setCodeTableErrorMessage(CODE_VALUE_REQUIRED));
        } else {
          let duplicateFound = false;

          for (let i = 0; i < data.length; i += 1) {
            for (let j = i + 1; j < data.length; j += 1) {
              if (
                data[i].codeValueID.codeValue.toLowerCase() ===
                data[j].codeValueID.codeValue.toLowerCase()
              ) {
                duplicateFound = true;
                dispatch(setChildCodeValueError(true));
                dispatch(setCodeTableErrorMessage(CODE_VALUE_EXIST));
                dispatch(
                  setDuplicateFound({
                    value: data[j].codeValueID.codeValue,
                    duplicate: true,
                  })
                );
                break;
              }
            }
            if (duplicateFound) {
              break;
            }
          }

          if (!duplicateFound) {
            dispatch(setChildCodeValueError(false));
            dispatch(setCodeTableErrorMessage(''));
            dispatch(setDuplicateFound({}));
          }
        }
      } else {
        dispatch(setChildCodeValueError(false));
        dispatch(setCodeTableErrorMessage(''));
        dispatch(setDuplicateFound({}));
      }
    };
    const resetSuccessMessage = () => {
      dispatch(setCodeTableSuccessMessage(''));
    };
    useImperativeHandle(ref, () => ({
      checkCodeValue() {
        const data =
          (selectedParentKey &&
            selectedParentKey.codeValue &&
            selectedParentKey.codeValue.filter((item) => !item.deleteFlag)) ||
          [];

        if (data.length > 0) {
          const emptyFilterArr = data.filter(
            (item) =>
              !item.codeValueID.codeValue || !item.codeValueID.codeValue.trim()
          );

          if (emptyFilterArr.length > 0) {
            dispatch(setChildCodeValueError(true));
            dispatch(setCodeTableErrorMessage(CODE_VALUE_REQUIRED));
          } else {
            let duplicateFound = false;

            for (let i = 0; i < data.length; i += 1) {
              for (let j = i + 1; j < data.length; j += 1) {
                if (
                  data[i].codeValueID.codeValue.toLowerCase() ===
                  data[j].codeValueID.codeValue.toLowerCase()
                ) {
                  duplicateFound = true;
                  dispatch(setChildCodeValueError(true));
                  dispatch(setCodeTableErrorMessage(CODE_VALUE_EXIST));
                  dispatch(
                    setDuplicateFound({
                      value: data[j].codeValueID.codeValue,
                      duplicate: true,
                    })
                  );
                  break;
                }
              }
              if (duplicateFound) {
                break;
              }
            }

            if (!duplicateFound) {
              dispatch(setChildCodeValueError(false));
              dispatch(setCodeTableErrorMessage(''));
              dispatch(setDuplicateFound({}));
            }
          }
        } else {
          dispatch(setChildCodeValueError(false));
          dispatch(setCodeTableErrorMessage(''));
          dispatch(setDuplicateFound({}));
        }
      },
    }));

    const handleFullScreenView = () => {
      setFullScreen(!fullScreen);
    };

    const handleViewHistory = (gridApi) => {
      const selectedRow = gridApi.getSelectedRows()?.[0]?.codeValueID;
      if (selectedRow !== undefined) {
        setShowViewHistory(true);
        setKeyValue({
          CODE_DOMAIN_KEY: `${selectedRow?.codeDomainKey}`,
          CODE_VALUE: `${selectedRow?.codeValue}`,
        });
      }
    };

    return (
      <div
        className={`table-container fourRecords no-border mt-${
          fullScreen ? 3 : 5
        }`}
      >
        <SaveCancelPopup
          open={openDelete}
          title="Delete"
          onConfim={() => handleDeleteRow()}
          onCancel={() => setOpenDelete(false)}
          moduleName=""
        />

        {errorModal && (
          <ErrorPopup
            errorPopupMessage="Please select a row to delete."
            onClose={() => setErrorModal(false)}
          />
        )}
        <Grid
          gridHeight={fullScreen ? '70vh' : 400}
          rowData={
            (selectedParentKey &&
              selectedParentKey.codeValue &&
              selectedParentKey.codeValue.filter((item) => !item.deleteFlag)) ||
            []
          }
          defaultCol={{ editable: false }}
          columnDefs={
            selectedParentKey && selectedParentKey.valuesProtectedInd === '1'
              ? CODE_VALUE_CELL_HEAD_DISABLE
              : CODE_VALUE_CELL_HEAD
          }
          frameworkComponents={{
            textFieldComponent: (props) => (
              <CodeTableCustomTextField
                {...props}
                validateBtnDisable={handleBlur}
                isReadOnly={
                  kcRoles?.userPrivileges?.includes('Developer')
                    ? false
                    : isReadOnly
                }
                disabled={
                  kcRoles?.userPrivileges?.includes('Developer')
                    ? false
                    : props.disabled
                }
                addAction={addRow}
              />
            ),
            deleteBoxRenderer: (props) => (
              <DeleteBoxRender
                {...props}
                isReadOnly={
                  kcRoles?.userPrivileges?.includes('Developer')
                    ? false
                    : isReadOnly
                }
                onClick={(data) => {
                  setChildSelected(data);
                  setOpenDelete(true);
                }}
              />
            ),
          }}
          fullScreenView={fullScreen}
          handleFullScreenViewClick={handleFullScreenView}
          navigateToNextCell={navigateToNextCell}
          // tabToNextCell={tabToNextCell}
          enterMovesDown
          suppressCellFocus
          onCellFocused={onCellFocused}
          exportFile
          data-testid="onEditingStopped"
          fileName="Code Value"
          addTxt="Add Code Value"
          addAction={addRow}
          disableAddAction={
            kcRoles?.userPrivileges?.includes('Developer')
              ? false
              : isReadOnly || selectedParentKey?.valuesProtectedInd === '1'
          }
          handleViewHistory={handleViewHistory}
        />
        {showViewHistory ? (
          <ViewHistoryComponent
            setShowViewHistory={setShowViewHistory}
            tableName="CODE_VALUE"
            keyValue={keyValue}
          />
        ) : null}
      </div>
    );
  }
);

export default CodeValueTable;
